import { HamburgerIcon } from "@chakra-ui/icons";
import {
  Button,
  Divider,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Flex,
  Heading,
  HStack,
  Link,
  Show,
  Stack,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import resume from "../Rajesh-Pachika-Resume.pdf";

const LINKS = [
  { to: "#home", title: "HOME" },
  { to: "#about", title: "ABOUT" },
  { to: "#skills", title: "SKILLS" },
  { to: "#projects", title: "PROJECTS" },
  { to: "#contact", title: "CONTACT" },
];

const Navbar = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();
  return (
    <>
      <Show above="sm">
        <Flex
          as={"header"}
          justify={"space-evenly"}
          position="fixed"
          w="100vw"
          h={"60px"}
          align={"center"}
          bg={"#00203FFF"}
          color="white"
          zIndex={10}
          id="navbar"
          transition={"top 0.3s"}
          p="20px"
        >
          <Link href="#home" _hover={{ textDecoration: "none" }}>
            <Heading fontWeight={"semibold"} fontSize={"3vw"}>
              Rajesh Pachika
            </Heading>
          </Link>
          <Flex justify={"space-evenly"} w="50%">
            {LINKS.map((link) => (
              <Link
                _hover={{ color: "#DB4437" }}
                fontWeight={""}
                href={link.to}
                key={link.to}
                fontSize={"1.5vw"}
              >
                {link.title}
              </Link>
            ))}
          </Flex>

          <Link
            borderRadius="20px"
            bg={"#DB4437"}
            color="white"
            p="8px"
            _hover={{ bg: "white", color: "black" }}
            fontWeight="bold"
            w={["60px", "80px", "100px"]}
            as={Link}
            href={resume}
            download
          >
            RESUME
          </Link>
        </Flex>
      </Show>

      <Show below="sm">
        <HStack
          justify={"space-between"}
          position={"fixed"}
          zIndex={"100"}
          w="100%"
          bgColor={"#00203FFF"}
          p="10px 40px"
          height="80px"
        >
          <Heading
            as={Link}
            href="#home"
            fontFamily={"mono"}
            color="white"
            textAlign={"center"}
          >
            Rajesh Pachika
          </Heading>
          <Button
            position={"fixed"}
            right="4"
            top="4"
            ref={btnRef}
            onClick={onOpen}
            borderRadius={"full"}
            bg={"#DB4437"}
            color="white"
            w="50px"
            h="50px"
          >
            <HamburgerIcon fontSize={"20px"} fontWeight="bold" />
          </Button>
          <Drawer
            isOpen={isOpen}
            placement="top"
            onClose={onClose}
            finalFocusRef={btnRef}
          >
            <DrawerOverlay />
            <DrawerContent bg={"#00203FFF"} color="white">
              <DrawerCloseButton />
              <Heading fontFamily={"mono"} textAlign={"center"}>
                Rajesh Pachika
              </Heading>
              <Divider />
              <DrawerBody>
                <Stack>
                  {LINKS.map((link) => (
                    <Link
                      _hover={{ color: "#DB4437" }}
                      fontWeight={"bold"}
                      href={link.to}
                      key={link.to}
                      textAlign="center"
                    >
                      {link.title}
                    </Link>
                  ))}
                </Stack>
              </DrawerBody>
            </DrawerContent>
          </Drawer>
        </HStack>
      </Show>
    </>
  );
};

export default Navbar;
